import { Grid, Typography } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import QCXFormStepWizard from '../../../../../shared-components/form-step-wizard/QCXFormStepWizard';

import QCXSelectPortoAeroportoAutocomplete from '../../../../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoAutocomplete';
import InputWithCleanButton from '../../../../../components/declaracao-importacao/inputWithCleanButton/InputWithCleanButton';
import QCXFinalAlternativeCurrencyField from '../../../../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectMoedaAutocomplete from '../../../../../shared-components/final-select-moeda-field/QCXSelectMoedaAutocomplete';
import QCXFinalDatePickerField from '../../../../../shared-components/final-date-picker-field/QCXFinalDatePickerField';
import QCXFinalTextField from '../../../../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalMultilineTextField from '../../../../../shared-components/final-text-field/QCXFinalMultilineTextField';
import QCXSelectTransportadorInternacionalAutocomplete from '../../../../../shared-components/select-transportador-internacional/QCXSelectTransportadorInternacionalAutocomplete';

export default function TarifarioMaritimoDataForm({
  initialValues,
  handleSubmit,
  isConsult,
  isUpdate,
  controlComponentProps,
  authInfo = {},
  requiredRoles = [],
}){

  const { t } = useTranslation();

  return (
    <QCXFormStepWizard
      initialValues={initialValues}
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
    >
      {({ values }) => (
        <>

          <Grid container spacing={2} style={{ marginTop: '1rem' }}>

            <Grid item xs={6} sm={6} md={6}>
              <InputWithCleanButton>
                <QCXSelectPortoAeroportoAutocomplete
                  id="select-field-local-condicao-venda"
                  key="select-field-local-condicao-venda"
                  name="origem.id"
                  label="Origem"
                  disabled={isConsult}
                  initialValues={values}
                />
              </InputWithCleanButton>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <InputWithCleanButton>
                <QCXSelectPortoAeroportoAutocomplete
                  id="select-field-local-condicao-venda"
                  key="select-field-local-condicao-venda"
                  name="destino.id"
                  label="Destino"
                  disabled={isConsult}
                  initialValues={values}
                />
              </InputWithCleanButton>
            </Grid>

 
            <Grid item xs={6} sm={6} md={6}>
              <QCXSelectTransportadorInternacionalAutocomplete
                id="autocomplete-select-agente-transportador-field"
                key="autocomplete-select-agente-transportador-field"
                name="transportadorInternacional"
                label="Armador"
                initialValues={values}
                disabled={isConsult}
                maritimoOnly
              />
            </Grid>

            <Grid item xs={3} sm={3} md={3}>
              <QCXSelectMoedaAutocomplete
                id="select-field-moeda-seguro"
                key="select-field-moeda-seguro"
                name="moeda.id"
                label="Serviço"
                disabled={isConsult}
                initialValues={values}
              />
            </Grid>

            <Grid item xs={3} sm={3} md={3}>
              <QCXFinalDatePickerField
                id="date-picker-field-data-registro"
                key="date-picker-field-data-registro"
                label="Validade"
                name="atributosAdicionais.dataRegistroSiscomex"
                disabled={isConsult}
              />
            </Grid>


            <Grid item xs={6} sm={6} md={6}>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-20dry-field"
                  name="dry20"
                  label="20' Dry"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-40dry-field"
                  name="dry40"
                  label="40' Dry"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-40highcubic-field"
                  name="tarifa40HighCubic"
                  label="40' High Cubic"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-20graneleiro-field"
                  name="graneleiro20"
                  label="20' Graneleiro"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-20flatrack-field"
                  name="flatRack20"
                  label="20' Flat Rack"
                  disabled={isConsult}
                  scale={7}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-40flatrack-field"
                  name="flatRack40"
                  label="40' Flat Rack"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-tank-field"
                  name="tank"
                  label="Tank"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-20opentop-field"
                  name="openTop20"
                  label="20' Open Top"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-40opentop-field"
                  name="openTop40"
                  label="40' Open Top"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-20reefer-field"
                  name="reefer20"
                  label="20' Reefer"
                  disabled={isConsult}
                  scale={7}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-40reefer-field"
                  name="reefer40"
                  label="40' Reefer"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-20nor-field"
                  name="nor20"
                  label="20' NOR"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-40nor-field"
                  name="nor40"
                  label="40' NOR"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-20plataforma-field"
                  name="plataforma20"
                  label="20' Plataforma"
                  disabled={isConsult}
                  scale={7}
                />
                <QCXFinalAlternativeCurrencyField
                  id="numeric-decimal-40plataforma-field"
                  name="plataforma40"
                  label="40' Plataforma"
                  disabled={isConsult}
                  scale={7}
                />
              </div>
            </Grid>


            <Grid item xs={6} sm={6} md={6}>
              <QCXSelectMoedaAutocomplete
                id="select-field-moeda-seguro"
                key="select-field-moeda-seguro"
                name="moeda.id"
                label="Moeda"
                disabled={isConsult}
                initialValues={values}
              />
            </Grid>


            <Grid item xs={6} sm={6} md={6}>
              <QCXFinalTextField
                id="text-field-numero-transmissao"
                key="text-field-numero-transmissao"
                label="Transit Time"
                name="transitTime"
                disabled={isConsult}
              />
            </Grid>

          </Grid>
        </>
      )}    
    </QCXFormStepWizard>
  )
}
